import { Col, Modal, Row } from 'antd';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface SendBidResultMessageModalProps {
  visible: boolean;
  sendBidResultMessage: () => void;
  onCancel: () => void;
}

function SendBidResultMessageModal({
  visible,
  sendBidResultMessage,
  onCancel,
}: SendBidResultMessageModalProps) {
  return (
    <StyledDiv>
      <Modal
        visible={visible}
        title="결과 메시지 보내기"
        okText="보내기"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => sendBidResultMessage()}
      >
        <>
          <Row justify="center">
            <Col span={12}>
              <h3>선정 결과를 공유하시겠습니까?</h3>
            </Col>
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default SendBidResultMessageModal;
